import { cn } from "@/shared/lib/utils";
import type { TableContainerProps } from "../types";

export const TableContainer = ({
  className,
  children,
}: TableContainerProps) => (
  <div className={cn("table-container w-full overflow-x-auto bg-white border rounded-lg", className)}>
    {children}
  </div>
);
